import styled from 'styled-components'

export const Body = styled.div`
  background: ${o => o.theme.color.deprecated.stoneLighter};
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 10px 13px;
  flex: 1;
`

export const ThreadIconWrapper = styled.span`
  font-size: 20px;
  margin-inline-end: 13px;
  align-self: flex-start;
  margin-top: 4px;
`

export const Text = styled.span`
  color: ${o => o.theme.color.text.primary.on.background};
  font-size: 11px;
  letter-spacing: 0.05em;
  line-height: 150%;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
